export interface SessionInfo { membership:string; memberId:string; quotaLeft:number; }
const TOKEN_KEY="bbmz.token";
export const activationClient={
  token(){try{return localStorage.getItem(TOKEN_KEY);}catch{return null;}},
  headers(){const token=this.token();return (token?{Authorization:`Bearer ${token}`}:{}) as Record<string,string>;},
  clear(){try{localStorage.removeItem(TOKEN_KEY);}catch{/* noop */}},
  async activate(code:string):Promise<SessionInfo>{
    const response=await fetch("/api/activate",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({code})});
    const data=await response.json() as {success?:boolean;token?:string;message?:string;membership?:string;memberId?:string;quotaLeft?:number};
    if(!response.ok||!data.success||!data.token) throw new Error(data.message||"激活失败");
    localStorage.setItem(TOKEN_KEY,data.token);
    return {membership:data.membership||"共识礼册会员",memberId:data.memberId||"",quotaLeft:data.quotaLeft||0};
  },
  async report(input:unknown){
    const response=await fetch("/api/report",{method:"POST",headers:{"Content-Type":"application/json",...this.headers()},body:JSON.stringify(input)});
    const data=await response.json() as {success?:boolean;report?:unknown;message?:string;quotaLeft?:number};
    if(!response.ok||!data.success) { if(response.status===401)this.clear(); throw new Error(data.message||"报告生成失败"); }
    return data;
  }
};
